/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AcknowledgeNoticeRequest,
  ActiveNoticeResponse,
  ConsumerGetSystemNoticeParams,
  GetActiveSystemNoticesParams,
  ProblemDetails,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get active system notices for a product
 */
export const getActiveSystemNotices = (
  params: GetActiveSystemNoticesParams,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<ActiveNoticeResponse[]>(
    { url: `/v1/system-notices`, method: 'GET', params, signal },
    options
  );
};

export const getGetActiveSystemNoticesQueryKey = (params?: GetActiveSystemNoticesParams) => {
  return [`/v1/system-notices`, ...(params ? [params] : [])] as const;
};

export const getGetActiveSystemNoticesQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: GetActiveSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveSystemNotices>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveSystemNoticesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveSystemNotices>>> = ({ signal }) =>
    getActiveSystemNotices(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveSystemNotices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActiveSystemNoticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveSystemNotices>>
>;
export type GetActiveSystemNoticesQueryError = ErrorType<ProblemDetails>;

export function useGetActiveSystemNotices<
  TData = Awaited<ReturnType<typeof getActiveSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: GetActiveSystemNoticesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveSystemNotices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveSystemNotices>>,
          TError,
          Awaited<ReturnType<typeof getActiveSystemNotices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveSystemNotices<
  TData = Awaited<ReturnType<typeof getActiveSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: GetActiveSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveSystemNotices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveSystemNotices>>,
          TError,
          Awaited<ReturnType<typeof getActiveSystemNotices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveSystemNotices<
  TData = Awaited<ReturnType<typeof getActiveSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: GetActiveSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveSystemNotices>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active system notices for a product
 */

export function useGetActiveSystemNotices<
  TData = Awaited<ReturnType<typeof getActiveSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: GetActiveSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveSystemNotices>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActiveSystemNoticesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a system notice by ID
 */
export const consumerGetSystemNotice = (
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<ActiveNoticeResponse>(
    { url: `/v1/system-notices/${noticeId}`, method: 'GET', params, signal },
    options
  );
};

export const getConsumerGetSystemNoticeQueryKey = (
  noticeId?: string,
  params?: ConsumerGetSystemNoticeParams
) => {
  return [`/v1/system-notices/${noticeId}`, ...(params ? [params] : [])] as const;
};

export const getConsumerGetSystemNoticeQueryOptions = <
  TData = Awaited<ReturnType<typeof consumerGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof consumerGetSystemNotice>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConsumerGetSystemNoticeQueryKey(noticeId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof consumerGetSystemNotice>>> = ({
    signal,
  }) => consumerGetSystemNotice(noticeId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!noticeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof consumerGetSystemNotice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ConsumerGetSystemNoticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof consumerGetSystemNotice>>
>;
export type ConsumerGetSystemNoticeQueryError = ErrorType<ProblemDetails>;

export function useConsumerGetSystemNotice<
  TData = Awaited<ReturnType<typeof consumerGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof consumerGetSystemNotice>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consumerGetSystemNotice>>,
          TError,
          Awaited<ReturnType<typeof consumerGetSystemNotice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useConsumerGetSystemNotice<
  TData = Awaited<ReturnType<typeof consumerGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof consumerGetSystemNotice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consumerGetSystemNotice>>,
          TError,
          Awaited<ReturnType<typeof consumerGetSystemNotice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useConsumerGetSystemNotice<
  TData = Awaited<ReturnType<typeof consumerGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof consumerGetSystemNotice>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a system notice by ID
 */

export function useConsumerGetSystemNotice<
  TData = Awaited<ReturnType<typeof consumerGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  params: ConsumerGetSystemNoticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof consumerGetSystemNotice>>, TError, TData>
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getConsumerGetSystemNoticeQueryOptions(noticeId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Acknowledge a system notice
 */
export const acknowledgeSystemNotice = (
  noticeId: string,
  acknowledgeNoticeRequest: AcknowledgeNoticeRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<void>(
    {
      url: `/v1/system-notices/${noticeId}/acknowledgements`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: acknowledgeNoticeRequest,
      signal,
    },
    options
  );
};

export const getAcknowledgeSystemNoticeMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeSystemNotice>>,
    TError,
    { noticeId: string; data: AcknowledgeNoticeRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeSystemNotice>>,
  TError,
  { noticeId: string; data: AcknowledgeNoticeRequest },
  TContext
> => {
  const mutationKey = ['acknowledgeSystemNotice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeSystemNotice>>,
    { noticeId: string; data: AcknowledgeNoticeRequest }
  > = (props) => {
    const { noticeId, data } = props ?? {};

    return acknowledgeSystemNotice(noticeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeSystemNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeSystemNotice>>
>;
export type AcknowledgeSystemNoticeMutationBody = AcknowledgeNoticeRequest;
export type AcknowledgeSystemNoticeMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Acknowledge a system notice
 */
export const useAcknowledgeSystemNotice = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acknowledgeSystemNotice>>,
      TError,
      { noticeId: string; data: AcknowledgeNoticeRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeSystemNotice>>,
  TError,
  { noticeId: string; data: AcknowledgeNoticeRequest },
  TContext
> => {
  const mutationOptions = getAcknowledgeSystemNoticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
